import { CSSProperties } from 'react';
import { useReduxState } from 'hooks';
import { ReaderCompletionNotification } from '.';

const ReaderWaitingForReviews = ({ style }: { style?: CSSProperties }) => {
  const {
    messages,
    pageState: { completion, completionId },
    theme
  } = useReduxState();

  return completionId ? null : completion?.status !==
    'waiting-for-reviews' ? null : (
    <ReaderCompletionNotification
      description={
        completion.tasksProgress
          ? messages.readerWaitingForReviewsFailed
          : messages.readerWaitingForReviewsDescription
      }
      descriptionStyle={{
        color: completion.tasksProgress ? theme.dangerColor : 'inherit'
      }}
      icon={completion.tasksProgress ? 'exclamation-circle' : 'hourglass-start'}
      iconStyle={{
        color: completion.tasksProgress ? theme.dangerColor : 'inherit'
      }}
      style={style}
    />
  );
};

export default ReaderWaitingForReviews;
